<template>
  <div class="page-triplea-home">
      <HomeSearchComponent />
      <HomeCategorySection />
      <CatalogSection :sectionTitle="'Veja esses destaques que selecionamos para você'" />
      <ShortStaySection />
      <CatalogSection :sectionTitle="'Lançamentos'" propertyType="''" />
      <ProspectingSection />
      <!-- <ExploreSection /> -->
      <!-- <AdvantagesSection/> -->
      <BestProperties />
      <BannerSection bg="#efebe7" />
      <AdvertiseModal />
      <TripleaContactModal />
  </div>
</template>
<script>

import "@/assets/scss/custom/triplea/_home.scss"

import Vue from "vue";
import HomeSearchComponent from '../components/apolar/triplea/home/home-search.vue'
import HomeCategorySection from '../components/apolar/triplea/home/home-category-section.vue'
import CatalogSection from '../components/apolar/triplea/catalog-section.vue'
import ProspectingSection from '../components/apolar/triplea/home/prospecting-section.vue'
import ExploreSection from '../components/apolar/triplea/home/explore-section.vue'
import BestProperties from '../components/apolar/triplea/home/best-properties.vue'
import BannerSection from '../components/apolar/triplea/home/banner-section.vue'
import AdvertiseModal from '../components/apolar/triplea/modals/advertise-modal.vue'
import TripleaContactModal from '../components/apolar/triplea/modals/contact-modal.vue'
import ShortStaySection from "../components/apolar/triplea/home/short-stay-section.vue";
import AdvantagesSection from "../components/apolar/triplea/home/advantages-section.vue";

export default {
  name: "triplea",
  components: {
    HomeSearchComponent,
    HomeCategorySection,
    CatalogSection,
    ProspectingSection,
    ExploreSection,
    BestProperties,
    BannerSection,
    AdvertiseModal,
    TripleaContactModal,
    ShortStaySection,
    AdvantagesSection
  },
  metaInfo() {
    return {
      title: "Imóveis de Alto Padrão Triple A | Apolar Imóveis",
    meta: [
      {
        vmid: "description",
        name: "description",
        content: "Conheça os imóveis Triple A da Apolar com infraestrutura moderna e localização premium. Ideal para quem busca qualidade."
      },
      {
        vmid: "robots",
        name: "robots",
        content: "index, follow"
      },
      {
        vmid: "canonical",
        rel: "canonical",
        href: "https://www.apolar.com.br/imoveis-triplea/"
      }
    ],
    link: [
      {
        rel: "canonical",
        href: "https://www.apolar.com.br/imoveis-triplea/"
      }
    ]
    };
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  }
};
</script>
